import supportGif from "@assets/gifs/support.gif";
import { VerificationState } from ".";
interface IResultStep {
  verificationData: VerificationState;
}

const ResultStep = ({ verificationData }: IResultStep) => {
  return (
    <div className="flex flex-col items-center">
      <p className="text-sm leading-5 text-center text-zinc-500 mt-8 md:mt-0">
        Your contact details have been confirmed: <span className="text-primary">{verificationData.email}</span> and{" "}
        <span className="text-primary">{verificationData.phone}</span>. Our support team will contact you shortly. After
        the call, your account will be confirmed and authenticated.
      </p>

      <div className="flex items-center gap-1 mt-10">
        <img src={supportGif} className="w-14 h-14" alt="support" />
        <p className="text-yellow-500 font-medium text-md md:text-xl">Waiting for call</p>
      </div>
    </div>
  );
};
export default ResultStep;
